<template>
  <div class="welcome-banner" :style="isDayTime() ? '':'color: white'">
    {{ $t("welcome") }}
    <div class="welcome-banner__highlight">{{ $t("esh.e") }}</div>
    <div class="welcome-banner__highlight">{{ $t("esh.sh") }}</div>
  </div>
</template>

<script>
export default {
  methods: {
    isDayTime() {
      var nowTime = moment().hour()
      if(nowTime >= 6 && nowTime < 18) return true;
      else return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.welcome-banner {
  font-size: 24px;
  font-weight: normal;
  color: #2d72c8;
  padding: 15px;
  border-left: 3px solid #CC4400;
  padding-left: 28px;
  margin-top: 32px;

  &__highlight {
    font-size: 44px;
    font-weight: bold;
    white-space: space break-all;
  }
}
</style>

<i18n src="@/locales/esh.locale.json"></i18n>
